import { t } from 'i18next'
import React, { useEffect } from 'react'
import { Grid, Segment } from 'semantic-ui-react'
import { FormFields } from '~/components/FormFields'
import i18n from '~/components/i18n'
import InfoPopup from '~/components/InfoPopup'

const logOutOptions = Array.from({ length: 10 }, (_, i) => i + 1).map((i) => i !== 0 ? ({
  text: i,
  value: i
}) : null)

const getRoleOptions = () => [
  {
    key: 'logoutTime',
    label: i18n.t('2FA Logout timer (minutes)'),
    info: i18n.t('Please set the time (in minutes) after which the user will be logged out automatically.'),
    options: [
      {
        value: 0,
        text: i18n.t('Deactivated')
      }
    ]
  },
  {
    key: 'tfaAbortTradingSlot',
    label: i18n.t('2FA Trading slot abort'),
    info: i18n.t('Enable two-factor authentication for ending a trading slot?')
  },
  {
    key: 'tfaCancellationAmount',
    label: i18n.t('2FA amount cancellation'),
    info: i18n.t('Enable two-factor authentication for canceling amounts of a trading slot?')
  },
  {
    key: 'tfaAbortAmount',
    label: i18n.t('2FA amount cancellation'),
    info: i18n.t('Enable two-factor authentication for canceling amounts of a trading slot?')
  },
  {
    key: 'tfaConfirmOffers',
    label: i18n.t('2FA Confirm offers'),
    info: i18n.t('Enable two-factor authentication for confirming offered amounts?')
  },
  {
    key: 'tfaLogin',
    label: i18n.t('2FA Login'),
    info: i18n.t('Enable two-factor authentication for the login process?')
  },
  {
    key: 'tfaNewsletterSend',
    label: i18n.t('2FA Newsletter send / plan'),
    info: i18n.t('Enable two-factor authentication for scheduling and sending a newsletter?')
  },
  {
    key: 'tfaOffer',
    label: i18n.t('2FA Offer'),
    info: i18n.t('Enable two-factor authentication for offering amounts during a trading slot?')
  },
  {
    key: 'tfaPlanning',
    label: i18n.t('2FA Plan and publish'),
    info: i18n.t('Enable two-factor authentication for planning and publishing a trading slot?')
  },
  {
    key: 'tfaPublishBasePrice',
    label: i18n.t('2FA Publish / change base price'),
    info: i18n.t('Enable two-factor authentication for publishing/changing a base price?')
  },
  {
    key: 'tfaGenerateBankFile',
    label: i18n.t('2FA Generate bank file'),
    info: i18n.t('Enable two-factor authentication for generating bank file')
  },
  {
    key: 'tfaGenerateMga',
    label: i18n.t('2FA Generate MGA'),
    info: i18n.t('Enable two-factor authentication for generating MGA')
  },
  {
    key: 'tfaMgaCloseMonth',
    label: i18n.t('2FA Close billing month'),
    info: i18n.t('Enable two-factor authentication for closing billing month')
  },
  {
    key: 'tfaArticlesImport',
    label: i18n.t('2FA articles import'),
    info: i18n.t('Enable two-factor authentication for articles import')
  }
]

interface RoleCardProps {
  control: any,
  role: any,
  index: number,
  getValues: (name: string) => void,
  watch: any
}

const RoleCard: React.FC<RoleCardProps> = (props) => {
  const { control, role, index, watch } = props
  const roleOptions = getRoleOptions()

  const watchRole = watch(`roles[${index}].logoutTime`)

  useEffect(() => {
    //handle watch role
  }, [watchRole, t])

  function renderSelect(roleOption) {
    return <FormFields.Select
      name={`roles[${index}][${roleOption.key}]`}
      options={[...roleOption.options, ...logOutOptions, { value: 20, text: 20 }]}
      placeholder={t('Select log out timer')}
      control={control}
      compact
      style={{ width: '30%' }}
      label={roleOption.label}
    />
  }

  function splitEvery(array, length) {
    return array.reduce(
      (result, item, index) => {
        if (index % length === 0) result.push([])
        result[Math.floor(index / length)].push(item)
        return result
      }, [])
  }

  function renderCard() {
    const logOutSelect = roleOptions[0]
    const filteredOptions = Object.keys(role).filter(key => roleOptions.find(roleOption => roleOption.key === key && role[key] !== 2) !== undefined)
    const splitOptions = splitEvery(filteredOptions, 4)

    return <Segment style={{ border: 'none' }}>
      {role[logOutSelect.key] !== undefined && role[logOutSelect.key] !== 2 ? renderSelect(logOutSelect) :
        logOutSelect.key === 'logoutTime' ? renderSelect(logOutSelect) : null}
      <Grid columns={splitOptions.length}>
        <Grid.Row>
          {splitOptions.map((options, index) => {
            return <Grid.Column key={`${role.id}${index}`}>
              {options.map(roleOptionKey => {
                const roleOption = roleOptions.find(roleOption => roleOption.key === roleOptionKey)
                const indexKey = filteredOptions.findIndex(key => key === roleOptionKey)
                return <div style={{ display: 'flex' }} key={`${role.id}${roleOptionKey}`}>
                  <FormFields.Checkbox
                    name={`roles[${props.index}][${filteredOptions[indexKey]}]`}
                    checkboxValue={roleOption.key === 'logoutTime' ? watchRole : 1}
                    control={control}
                    label={roleOption.label}
                  />
                  <InfoPopup
                    content={roleOption.info}
                    styleIcon={{ marginLeft: 3, cursor: 'pointer' }}
                  />
                </div>
              })}
            </Grid.Column>
          })}
        </Grid.Row>
      </Grid>
    </Segment>
  }

  return <>
    {renderCard()}
  </>
}
export default RoleCard
